import { render } from "./index.vue?vue&type=template&id=53add4b1"
import script from "./three-animation.js?vue&type=script&lang=js"
export * from "./three-animation.js?vue&type=script&lang=js"

import "./three-animation.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "C:\\Users\\devin\\Desktop\\Web\\Portfolios\\Portolio\\vue-personal-portfolio\\portfolio\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__